import { FC } from 'react'
import styled from 'styled-components'

interface IFProps {
  tooltipType: 'myScore' | 'average' | false
  value: number
}

const SpredScoreInfoTableColumns: FC<IFProps> = ({ tooltipType, value }) => {
  return (
    <StyledWrapper data-tooltip-type={tooltipType}>
      {value}
      {tooltipType && (
        <span
          role="tooltip"
          className="tooltip"
          data-tooltip-type={tooltipType}
        >
          {tooltipType === 'myScore' ? '나의 점수' : '전체 평균 점수'}
        </span>
      )}
    </StyledWrapper>
  )
}

export default SpredScoreInfoTableColumns

const StyledWrapper = styled.div`
  position: relative;
  padding: 14px 0px;
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: -0.64px;
  text-align: center;
  color: #333;

  > .tooltip {
    position: absolute;
    border-radius: 4px;
    display: block;
    z-index: 20;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: -0.56px;
    text-align: center;
    color: #fff;
    padding: 8px 12px;
    background-color: #666666;
    transform: translate(100%, -50%);
    top: 50%;
    right: -3%;
    box-shadow: 1px 2px 4px 0 rgba(102, 102, 102, 0.16);

    &[data-tooltip-type='myScore'] {
      color: #ffdf11;
      z-index: 30;
    }

    &[data-tooltip-type='average'] {
      color: #ffffff;
    }

    &::after {
      border-color: transparent #666666;
      border-style: solid;
      border-width: 8px 8px 8px 0px;
      margin-top: -5px;
      content: '';
      display: block;
      top: 50%;
      position: absolute;
      left: -6.5px;
      width: 0;
      z-index: 1;
    }
    &::before {
      border-color: transparent #bbbbbb;
      border-style: solid;
      border-width: 8px 8px 8px 0px;
      margin-top: -5px;
      content: '';
      display: block;
      top: 50%;
      position: absolute;
      left: -8px;
      width: 0;
      z-index: 0;
    }
  }

  &[data-tooltip-type='myScore'] {
    background-color: #edf9ff;
  }

  &[data-tooltip-type='average'] {
    background-color: #f8fdff;
  }
`
